import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export default function InvitationExpiredPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <div className="flex justify-center mb-4">
            <div className="rounded-full bg-yellow-100 p-3">
              <svg
                className="h-12 w-12 text-yellow-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
          </div>
          <CardTitle className="text-2xl font-bold text-center">
            Convite Expirado
          </CardTitle>
          <CardDescription className="text-center">
            Este link de convite não é mais válido
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <p className="text-sm text-yellow-800">
              O link de convite que você tentou usar expirou ou já foi utilizado.
              Os convites são válidos por 7 dias após o envio.
            </p>
          </div>

          <div className="space-y-3">
            <div className="text-sm text-muted-foreground">
              <p className="font-medium mb-2">O que fazer agora?</p>
              <ul className="list-disc list-inside space-y-1 ml-2">
                <li>Entre em contato com o administrador da organização</li>
                <li>Solicite um novo convite</li>
                <li>Verifique se você já tem uma conta criada</li>
              </ul>
            </div>
          </div>

          <div className="space-y-2 pt-2">
            <Button
              className="w-full"
              onClick={() => navigate('/login')}
            >
              Ir para Login
            </Button>
            <Button
              variant="outline"
              className="w-full"
              onClick={() => navigate('/signup')}
            >
              Criar Nova Conta
            </Button>
          </div>

          <div className="text-center text-xs text-muted-foreground pt-2">
            Precisa de ajuda?{' '}
            <a href="mailto:suporte@talentumiq.com" className="text-primary hover:underline">
              Entre em contato
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
